import * as React from 'react';

import {Button} from 'shells/button/button';
import {Dialog} from 'shells/dialog/dialog';

type Props = {
    isWebFxAudience: boolean;
    selectedItemCount: number;
    onRemove: (audienceId: string) => void;
    audienceName: string;
    audienceId: string;
};

export function RemoveFromAudienceButton(props: Props) {
    const removeButtonRef = React.useRef();
    const [showRemoveConfirmation, setShowRemoveConfirmation] = React.useState<boolean>(false);

    return (
        <>
            <Button
                disabled={props.isWebFxAudience}
                size='big'
                variant='danger'
                onClick={() => {
                    setShowRemoveConfirmation(true);
                }}
                getButtonRef={removeButtonRef}
                tooltipText={
                    props.isWebFxAudience
                        ? 'MCFX audiences cannot be managed in Nutshell'
                        : undefined
                }
            >
                Remove from audience
            </Button>
            {showRemoveConfirmation ? (
                <Dialog
                    anchor={removeButtonRef.current}
                    location='top'
                    isWarning={false}
                    question={`Are you sure you want to remove ${props.selectedItemCount} ${
                        props.selectedItemCount === 1 ? 'person' : 'people'
                    } from ${props.audienceName ? props.audienceName : 'this audience'}?`}
                    onPrimary={() => {
                        setShowRemoveConfirmation(false);

                        props.onRemove(props.audienceId);
                    }}
                    onSecondary={() => {
                        setShowRemoveConfirmation(false);
                    }}
                />
            ) : undefined}
        </>
    );
}
